// 日志
import service from '@/utils/request'

// 查询管理员日志列表
export function adminLogList(data) {
    return service({
        url: '/service/admin/adminLogList',
        method: 'get',
        params: data
    })
}

// 查询管理员登录记录列表
export function adminTokenList(data) {
    return service({
        url: '/service/admin/adminTokenList',
        method: 'get',
        params: data
    })
}

// 查询用户日志列表
export function userLogList(data) {
    return service({
        url: '/service/admin/userLogList',
        method: 'get',
        params: data
    })
}
